var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60676 6.00081L6.79752 1.11216C6.96704 0.952461 7.03703 0.716124 6.98103 0.491946C6.92514 0.267883 6.75172 0.0901766 6.52614 0.0256687C6.30062 -0.0386951 6.05735 0.0199354 5.88778 0.179635L0.202622 5.53445C0.0731904 5.65623 0 5.82457 0 6.00075C0 6.17691 0.0731904 6.34525 0.202622 6.46703L5.88778 11.8204C6.05729 11.9801 6.30059 12.0387 6.52614 11.9743C6.75166 11.9099 6.92508 11.7322 6.98103 11.508C7.03703 11.2839 6.96704 11.0475 6.79752 10.8879L1.60676 6.00081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrowicon);
export default __webpack_public_path__ + "static/media/leftarrowicon.6d3771de6209634381320809cf177488.svg";
export { ForwardRef as ReactComponent };